/* eslint-disable */
import React from 'react'
import { hexbin } from 'd3-hexbin'
import { max } from 'd3-array'
import { scaleSqrt } from 'd3-scale'

import filter from 'lodash/filter'

import { RemoveBadSprayPoints } from '../../Utilities/RemoveBadPoints.ts'
import CalculateHitLocation from '../../Utilities/CalculateHitLocation'

import RunCalculations from '../../Utilities/RunCalculations.ts'
import ColorPalette from '../../Utilities/Colors/Palettes.ts'

import HexLegend from '../../Legend/HexLegend.tsx'

export default function HexBin({ settings, chartOptions = {} }) {
    const pitchData = settings.data
    const chartType = chartOptions.type
    const radiusSize = 14

    const hex = hexbin()
        .x(
            (d) =>
                CalculateHitLocation(
                    { x: d.x, y: d.y },
                    settings.vizWidth,
                    settings.vizHeight
                ).x
        )
        .y(
            (d) =>
                CalculateHitLocation(
                    { x: d.x, y: d.y },
                    settings.vizWidth,
                    settings.vizHeight
                ).y
        )
        .radius((radiusSize * settings.vizWidth) / settings.vizWidth - 1)
        .extent([
            [0, 0],
            [settings.vizWidth - 0, settings.vizHeight - 0],
        ])

    const bins = hex(pitchData)
    for (let i = 0; i < bins.length; i++) {
        bins[i].calculations = RunCalculations(bins[i])
    }

    const palette = new ColorPalette({
        type: chartType,
        data: bins,
    })

    const { color } = palette

    const maxCount = max(bins, (d) => d.length)
    const minRadius = 5
    let radius = scaleSqrt([1, maxCount], [minRadius, hex.radius()])

    if (!chartOptions.scaleRadius) {
        radius = function () {
            return radiusSize
        }
    }

    return (
        <>
            <g id="hexbinChart">
                {bins.map((d, i) => (
                    <path
                        key={`hexPath_${i}`}
                        d={hex.hexagon(radius(d.length), d)}
                        transform={`translate(${d.x},${d.y})`}
                        fill={
                            d
                                ? color(Number(d.calculations[chartType]))
                                : '#000'
                        }
                        stroke="#000"
                        opacity={chartOptions.opacity}
                    />
                ))}
            </g>
            {chartOptions.legend ? (
                <HexLegend
                    type="field"
                    settings={settings}
                    hex={hex}
                    color={color}
                    radius={radius}
                    maxCount={maxCount}
                    chartType={chartType}
                    chartOptions={chartOptions}
                />
            ) : null}
        </>
    )
}
